export const AGENT = 'agent';
export const AGENT_ADMIN = 'agent-admin';
